export default "__VITE_ASSET__BTc7OiTW__"